'use strict'
/* eslint-disable */
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import configurazioni from '@/services/configurazioniService.js'
import scontrini from '@/services/scontriniService.js'
import documenti from '@/services/documentiService.js'
import magazzino from '@/services/magazzinoService.js'
import funzioni_01 from '../elementi/funzioni_01'

const totalePerTipoItem = function(context, tipoItem, azienda) {
  let righe = context.righeCarrello.filter(x => x.azienda === azienda.codice || !x.azienda && azienda.aziendaBase)
  let st = 0
  for(var i = 0; i < righe.length; i++) {
    if (!['subtotale', 'separatore', 'lotteria', 'codicefiscale', 'cortesia', 'descrizione'].includes(righe[i].tipo) && righe[i].tipoBene === tipoItem) {
      st += parseFloat(righe[i].prezzo)
      if (righe[i].sconto) {
        st += parseFloat(righe[i].sconto.prezzo || 0)
      }
      if (righe[i].abbuono) {
        st += parseFloat(righe[i].abbuono.prezzo || 0)
      }
      if(righe[i].variazioni && righe[i].variazioni.length > 0) {
        for (let v of righe[i].variazioni) {
          if (v.deltaPrezzo) {
            st += parseFloat(v.deltaPrezzo) * righe[i].quantita || 0
          }
        }
      }
      if(righe[i].preparazioni && righe[i].preparazioni.length > 0) {
        for (let p of righe[i].preparazioni) {
          if (p.deltaPrezzo) {
            st += parseFloat(p.deltaPrezzo) * righe[i].quantita || 0
          }
        }
      }      
    }
  }
  return st.toFixed(2)
}

function addNota(righeCarrello, { tipoRiga, nota, prezzo, payload, quantita }) {
  var riga = {
    quantita: quantita || 0,
    descrizione: nota,
    prezzoUnitario: 0,
    prezzo: prezzo,
    tipo: tipoRiga,
    payload,
    rigaCodice: uuidv4()
  };
  righeCarrello.push(riga)
  // context.rigaCarrello = riga
}

const chiudiScontrino = (context) => {
  let righeDisplay = []
  let righeChiusura = {}
  let infoChiusura = {}
  context.stampaInCorso = true
  context.scontrinoEspanso = true
  const multiAzienda = _.get(context, 'impostazioni.multiazienda')
  let cartaDiCredito_tot = context.importoPagato.cartadicredito || 0
  let contanti_tot = context.importoPagato.contanti || 0
  let nonRiscosso_tot = context.importoPagato.nonriscosso || 0
  let daStampare = []
  for (let azienda of multiAzienda) {
    let totaleScontrino = +parseFloat(totalePerTipoItem(context, "PRODOTTO", azienda)).toFixed(2)
    if (totaleScontrino === 0) {
      continue
    }
    let daPagare = totaleScontrino
    let infoChiusuraScontrino = {
      pagamenti: [],
      contanti: 0,
      totale: null,
      resto: null
    }
    let scontoAPagare = parseFloat(context.importoPagato.scontoapagare || 0) // Solo sul primo ?
    let nonRiscosso = nonRiscosso_tot
    if (daPagare < nonRiscosso) {
      nonRiscosso = daPagare
    }
    nonRiscosso_tot -= nonRiscosso
    daPagare -= nonRiscosso

    let cartaDiCredito = cartaDiCredito_tot
    if (daPagare < cartaDiCredito) {
      cartaDiCredito = daPagare
    }
    cartaDiCredito_tot -= cartaDiCredito
    daPagare -= cartaDiCredito

    let contanti = contanti_tot
    if (daPagare < contanti) {
      contanti = daPagare
    }
    contanti_tot -= contanti
    daPagare -= contanti

    let resto = context.resto
    let totali = {
      totaleScontrino,
      scontoAPagare,
      cartaDiCredito,
      contanti,
      nonRiscosso,
      resto
    }
    let righeCarrello = context.righeCarrello.filter(x => x.azienda === azienda.codice || !x.azienda && azienda.aziendaBase)
    let righeNonFiscali = context.righeNonFiscali.filter(x => x.azienda === azienda.codice || !x.azienda && azienda.aziendaBase)
    if (righeCarrello.length > 0 || righeNonFiscali.length > 0) {
      daStampare.push(azienda.idScontriniMachine)
      chiudiScontrinoX(context, azienda.idScontriniMachine, infoChiusuraScontrino, totali, righeCarrello, righeNonFiscali)
      righeChiusura[azienda.idScontriniMachine] = righeCarrello
      infoChiusura[azienda.idScontriniMachine] = infoChiusuraScontrino

      // Lo scontrino visualizzato riporta tutte le righe separate per azienda
      if (righeDisplay.length > 0) {
        addNota(righeDisplay, { tipoRiga: 'descrizione', nota: '' })
        addNota(righeDisplay, { tipoRiga: 'separatore', nota: '', prezzo: '' })
        addNota(righeDisplay, { tipoRiga: 'separatore', nota: '', prezzo: '' })
      }
      addNota(righeDisplay, { tipoRiga: 'descrizione', nota: _.get(azienda, 'scontrino.descrizione', '--------') })
      righeDisplay = righeDisplay.concat(righeCarrello)
    }
  }


  return { infoChiusura, righeChiusura, daStampare, righeDisplay }
}

const chiudiScontrinoX = (context, idScontriniMachine, infoChiusuraScontrino, totali, righeCarrello, righeNonFiscali) => {
  // Verificare se ricostruire tutto lo scontrino (anche se è già stato salvato su db ...)
  delete infoChiusuraScontrino.stato
  infoChiusuraScontrino.pagamenti.length = 0
  addNota(righeCarrello, { tipoRiga: 'separatore', nota: '', prezzo: '' })

  let scontoapagare = parseFloat(totali.scontoapagare || 0)
  let totaleComplessivo = parseFloat(totali.totaleScontrino) + scontoapagare

  let totaleNonFiscale = 0
  for (let r of righeNonFiscali.filter(x => ['PRODOTTO', 'SERVIZIO'].includes(x.tipoBene))) {
    totaleNonFiscale += parseFloat(r.prezzo)
  }

  addNota(righeCarrello, { tipoRiga: 'totalecomplessivo', nota: 'Totale complessivo', prezzo: (totaleComplessivo - totaleNonFiscale).toFixed(2) })

  // TODO: Creare pagamenti generici da associare a tasti particolari (es. eBay)
  if (totali.scontoapagare > 0) {
    infoChiusuraScontrino.pagamenti.push({ tipo: 'scontoapagare', importo: totali.scontoapagare })
    addNota(righeCarrello, { tipoRiga: 'scontoapagare', nota: 'Sconto a pagare (Reso)', prezzo: parseFloat(totali.scontoapagare).toFixed(2) })
  }
  if (totali.cartaDiCredito > 0) {
    infoChiusuraScontrino.pagamenti.push({ tipo: 'cartadicredito', importo: totali.cartaDiCredito })
    addNota(righeCarrello, { tipoRiga: 'cartadicredito', nota: 'Carta di Pagamento', prezzo: parseFloat(totali.cartaDiCredito).toFixed(2) })
  }
  if (totali.nonRiscosso > 0) {
    infoChiusuraScontrino.pagamenti.push({ tipo: 'nonriscosso', importo: totali.nonRiscosso })
    addNota(righeCarrello, { tipoRiga: 'nonriscosso', nota: 'Non riscosso', prezzo: parseFloat(totali.nonRiscosso).toFixed(2) })
  }  
  // **********************************************************************************************************************
  // **********************************************************************************************************************
  // *********************            TUTTO IL RESTO SOLO SE STAMPANTE 1        *******************************************
  // **********************************************************************************************************************
  // **********************************************************************************************************************
  let importoBuoni = 0
  let importoBuoniMonouso = 0
  let importoFidelityCard = 0
  if (idScontriniMachine === 1) {
    if (context.importoPagato.buonipasto > 0) {
      infoChiusuraScontrino.pagamenti.push({ tipo: 'buonipasto', importo: context.importoPagato.buonipasto, payload: context.tagliSelezionati })
      const numBP = _.sumBy(context.tagliSelezionati, 'numeroSelezionati')
      addNota(righeCarrello, { tipoRiga: 'buonipasto', nota: 'Buoni Pasto', prezzo: parseFloat(context.importoPagato.buonipasto).toFixed(2), quantita: numBP, payload: context.tagliSelezionati })
    }
    // TODO: Verificare se come nonRiscosso
    if (context.importoPagato.nonriscossobeni > 0) {
      infoChiusuraScontrino.pagamenti.push({ tipo: 'nonriscossobeni', importo: context.importoPagato.nonriscossobeni })
      addNota(righeCarrello, { tipoRiga: 'nonriscossobeni', nota: 'Non riscosso Beni', prezzo: parseFloat(context.importoPagato.nonriscossobeni).toFixed(2) })
    }
    if (context.importoPagato.nonriscossoservizi > 0) {
      infoChiusuraScontrino.pagamenti.push({ tipo: 'nonriscossoservizi', importo: context.importoPagato.nonriscossoservizi })
      addNota(righeCarrello, { tipoRiga: 'nonriscossoservizi', nota: 'Non riscosso Servizi', prezzo: parseFloat(context.importoPagato.nonriscossoservizi).toFixed(2) })
    }
    
    if (context.importoPagato.buonimultiuso > 0) {
      importoBuoni = context.importoPagato.buonimultiuso
      infoChiusuraScontrino.pagamenti.push({ tipo: 'buonimultiuso', importo: context.importoPagato.buonimultiuso })
      addNota(righeCarrello, { tipoRiga: 'buonimultiuso', nota: 'Buoni multiuso', prezzo: parseFloat(context.importoPagato.buonimultiuso).toFixed(2) })

      context.buonoMultiusoUtilizzo = context.buonoMultiuso.buono.utilizzi.length // posizione in cui viene salvato (per aggiornamento numero scontrino)
      for(let b of context.buoniMultiuso) {
        const uso = {
          data: new Date(),
          importo: +parseFloat(b.buono.usoAttuale).toFixed(2)
        }

        b.buono.utilizzi.push(uso)
      }
    }
    
    if (context.importoPagato.buonimonouso > 0) {
      importoBuoniMonouso = context.importoPagato.buonimonouso
      infoChiusuraScontrino.pagamenti.push({ tipo: 'buonimonouso', importo: context.importoPagato.buonimonouso })
      addNota(righeCarrello, { tipoRiga: 'buonimonouso', nota: 'Buoni monouso', prezzo: parseFloat(context.importoPagato.buonimonouso).toFixed(2) })
      addNota(righeCarrello, { tipoRiga: 'descrizione', nota: 'Utilizzo buono nr. ' + context.buonoMonouso.codice })
      const uso = {
        data: new Date(),
        importo: parseFloat(context.importoPagato.buonimonouso).toFixed(2) // va saldato tutto il buono ?
      }
      context.buonoMonousoUtilizzo = context.buonoMonouso.buono.utilizzi.length // posizione in cui viene salvato (per aggiornamento numero scontrino)
      context.buonoMonouso.buono.utilizzi.push(uso)
    }
  
    if (context.importoPagato.fidelitycard > 0) {
      importoFidelityCard = context.importoPagato.fidelitycard
      infoChiusuraScontrino.pagamenti.push({ tipo: 'fidelitycard', importo: context.importoPagato.fidelitycard })
      addNota(righeCarrello, { tipoRiga: 'fidelitycard', nota: 'Fidelity card', prezzo: parseFloat(context.importoPagato.fidelitycard).toFixed(2) })
      addNota(righeCarrello, { tipoRiga: 'descrizione', nota: 'Utilizzo card nr. ' + context.fidelityCard.codice })
      const uso = {
        data: new Date(),
        importo: parseFloat(context.importoPagato.fidelitycard).toFixed(2)
      }
      context.fidelityCardUtilizzo = context.fidelityCard.buono.utilizzi.length // posizione in cui viene salvato (per aggiornamento numero scontrino)
      context.fidelityCard.buono.utilizzi.push(uso)
    }
  }

  if (totali.contanti > 0) {
    infoChiusuraScontrino.pagamenti.push({ tipo: 'contanti', importo: +totali.contanti.toFixed(2) })
    addNota(righeCarrello, { tipoRiga: 'contanti', nota: 'Pagamento contante', prezzo: parseFloat(totali.contanti).toFixed(2) })
  }

  addNota(righeCarrello, { tipoRiga: 'separatore', nota: '', prezzo: '' })

  if (totali.resto != null) { // verificare se solo > 0
    infoChiusuraScontrino.resto = totali.resto
    addNota(righeCarrello, { tipoRiga: 'resto', nota: 'Resto', prezzo: parseFloat(totali.resto).toFixed(2) })
  } else {
    infoChiusuraScontrino.resto = null
  }
  const importoPagato = totaleComplessivo - importoBuoni - importoBuoniMonouso - importoFidelityCard

  infoChiusuraScontrino.totale = importoPagato

  let payload = null
  if (context.impostazioni.operatori.scontrino.abilitato) {
    const tipoInfo = context.impostazioni.operatori.scontrino.tipoInfo || 'descrizione'
    const op = funzioni_01.fnGetNomeOperatore(context, tipoInfo)
    if (op) {
      payload = { operatore : `${context.impostazioni.operatori.scontrino.messaggio || 'Siete stati serviti da'}: ${op}` }
    }
  }

  if (funzioni_01.fnGetOperatore(context)) {
    infoChiusuraScontrino.operatore = { codice: funzioni_01.fnGetOperatore(context), descrizione: funzioni_01.fnGetNomeOperatore(context, 'descrizione') }
  }

  if (righeCarrello.some(x => x.ssnn)) {
    payload = payload || {}
    payload.ssnn = {
      legenda: _.get(context.impostazioni, 'ssnn.legendaStampante', [])
    }
  }

  if (context.noteDiCoda && context.noteDiCoda.length > 0) {
    payload = payload || {}
    payload.noteDiCoda = context.noteDiCoda
    context.noteDiCoda = []
  }
  if (idScontriniMachine === 1) {
    if (context.coupon) {
      payload = payload || {}
      payload.noteDiCoda = payload.noteDiCoda || []
      const infoCoupon = _.get(context.impostazioni, 'fidelityCard.coupon.infoScontrino')
      if (infoCoupon) {
        payload.noteDiCoda.push(infoCoupon.apertura || '')
        payload.noteDiCoda.push((infoCoupon.codice || '').replace('#CODICE#', context.coupon.codice))
        payload.noteDiCoda.push(infoCoupon.chiusura || '')
      }

    }

    if (context.fidelityCard) {
      const impCard = _.get(context.impostazioni, 'fidelityCard.scontrino', null)
      payload = payload || {}
      if (impCard && impCard.infoFidelity) {
        const infoPunti = context.fidelityCard.infoPunti
        payload.fidelity = {
          numero: `${impCard.labelNumeroCarta || 'Carta'}: ${context.fidelityCard._id}`
        }
        if (impCard.saldoPunti) {
          payload.fidelity.saldo = `${impCard.labelSaldo || 'Tot. punti'}: ${infoPunti.totale || '---'}`
        }
        if (impCard.saldoCompleto) {
          payload.fidelity.puntiPrecedenti = `${impCard.labelPrecedenti || 'Pt. precedenti'}: ${infoPunti.puntiPrecedenti || '---'}`
          payload.fidelity.puntiScontrino = `${impCard.labelCorrenti || 'Pt. scontrino'}: ${infoPunti.puntiScontrino || '---'}`
        }
        payload.fidelity.titolo = impCard.titolo
        if (context.fidelityCard.offerteAttive) {
          payload.fidelity.tipoOfferta = `${impCard.labelOffertaAttiva || 'Off.'}: ${context.fidelityCard.offerteAttive.descrizione}`
        }
        infoChiusuraScontrino.fidelity = { ...context.fidelityCard.infoPunti, card: context.fidelityCard._id }
      }
    } else {
      infoChiusuraScontrino.fidelity = null
    }
  }
  addNota(righeCarrello, { tipoRiga: 'totale', nota: 'Importo pagato', prezzo: +(totali.totaleScontrino - totaleNonFiscale).toFixed(2), payload })

  if (context.tipoDocumento !== 'scontrino') {
    addNota(righeCarrello, { tipoRiga: 'separatore', nota: '', prezzo: '' })
    if (context.tipoDocumento === 'scontrinoSegueFattura') {
      addNota(righeCarrello, { tipoRiga: 'descrizione', nota: _.get(context.impostazioni, 'documenti.scontrinoSegueFattura.descrizione', 'Segue fattura') })
    } else {
      // Se i documenti sono separati per azienda, anche gli scontrini lo sono --> un documento per scontrino 
      // TODO: Correggere
      // addNota(context, { tipoRiga: 'descrizione', nota: `Emessa ${context.tipoDocumentoDesc}: ${context.documento.codice}` })

      if (typeof Array.isArray(context.documento)) {
        const aziende = context.impostazioni.multiazienda
        const azienda = aziende.find(x => x.idScontriniMachine === idScontriniMachine)
        for (let doc of context.documento.filter(x => x.azienda === azienda.codice)) {
          addNota(righeCarrello, { tipoRiga: 'descrizione', nota: `Emessa ${context.tipoDocumentoDesc}: ${doc.codice}` })
        }
      } else {
        addNota(righeCarrello, { tipoRiga: 'descrizione', nota: `Emessa ${context.tipoDocumentoDesc}: ${context.documento.codice}` })
      }
    }
  }
  if (context.cliente) {
    infoChiusuraScontrino.cliente = {
      codice: context.cliente.codice,
      ragioneSociale: context.cliente.ragioneSociale
    }
  }
}

const esegueMovimentiMagazzino = async (context, idScontriniMachine) => {
  let multiAzienda = _.get(context, 'impostazioni.multiazienda')
  if (idScontriniMachine) {
    multiAzienda = multiAzienda.filter(x => x.idScontriniMachine === idScontriniMachine)
  }
  for (let azienda of multiAzienda) {
    let righeCarrello = context.righeCarrello.filter(x => x.azienda === azienda.codice || !x.azienda && azienda.aziendaBase)
    let righeNonFiscali = context.righeNonFiscali.filter(x => x.azienda === azienda.codice || !x.azienda && azienda.aziendaBase)    
    await esegueMovimentiMagazzinoX(context, azienda.idScontriniMachine, righeCarrello, righeNonFiscali)
  }
}

const esegueMovimentiMagazzinoX = async (context, idScontriniMachine, righeCarrello, righeNonFiscali) => {
  // TODO Verificare se per multiazienda deve ciclare su più scontrini
  console.log('esegui_movimenti_magazzino')
  let scontrinoStampato = context[`scontrinoStampato${idScontriniMachine && idScontriniMachine !== 1 ? idScontriniMachine : '' }`]
  let idScontrino = context[`idScontrino${idScontriniMachine && idScontriniMachine !== 1 ? idScontriniMachine : '' }`]
  let scontrino = scontrinoStampato || { _id: idScontrino }
  const magazzinoMovimenti = configurazioni.getMagazzinoMovimenti()
  if (context.cliente && scontrino) { //TODO: VERIFICARE ####
    scontrino.cliente = context.cliente
    scontrino.listino = context.listino
  }
  // aggiungere righeNonFiscali !== VINCITA: Verificare scontrino misto / scontrino solo non fiscale
  // const righeMovimenti = (context.righeCarrello).concat(context.righeNonFiscali.filter(x => x.tipoBene !== 'VINCITA'))

  const righeMovimenti = righeCarrello.concat(righeNonFiscali)
  // const aziende = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'aziende')
  const aziende = context.impostazioni.multiazienda
  const azienda = aziende.find(x => x.idScontriniMachine === idScontriniMachine)
  if (righeMovimenti.length > 0) {
    // TODO: Deve separare anche i documenti (ogni dovumento ha solo i prodotti della relativa azienda)
    const documento = context.documento && context.documento.find(x => x.azienda === azienda.codice)
    
    let causaleMovimenti = _.get(context, 'impostazioni.movimenti.causale.' + context.tipoDocumento) || 'venditaClienti'
    await magazzino.creaMovimentiScontrino('scontrino', magazzinoMovimenti, causaleMovimenti, righeMovimenti, scontrino, documento, context.cpc)
  }

  // Devo aggiornare manualmente il documento se non ho righe fiscali, altrimenti rimane nello stato di aperto
  // ATTENZIONE verificare: La procedura chiude comunque lo scontrino anche se lato pagamento potrebbero esserci problemi ...

  if (righeNonFiscali.length > 0 && context.tipoDocumento === 'scontrino') {
    await scontrini.aggiornaDocumentoScontrino(idScontrino, null, righeNonFiscali)
  }
  if (context.tipoDocumento !== 'scontrino') {
    await scontrini.aggiornaDocumentoScontrino(idScontrino, context.documento)
    if (context.tipoDocumento !== 'scontrinoSegueFattura' ) {
      if (Array.isArray(context.documento)) {
        for (let d of context.documento) {
          await documenti.aggiornaScontrinoDocumento(d._id, idScontrino)
        }
      } else {
        await documenti.aggiornaScontrinoDocumento(context.documento._id, idScontrino)
      }
    }
  }
  if (_.get(context.impostazioni, 'cassa.contabili.vincite', false) && context.totaleVincite > 0) {
    const operatore = { codice: funzioni_01.fnGetOperatore(context), descrizione: funzioni_01.fnGetNomeOperatore(context) }
    context.inputDescrizione = 'Pagamento vincita'
    await operazioniCassa.cassaMovimenti(context, { value: 'VINCITA' }, operatore, configurazioni.getPostazione(), context.totaleVincite)
  }
  return true
}

export default {
  chiudiScontrino,
  esegueMovimentiMagazzino
}
